import type { FunctionComponent, HTMLAttributes } from "preact";
import { useMergedClassName } from "../utils.ts";

export type FooterRecordProps = HTMLAttributes<HTMLDivElement>;

export const FooterRecord: FunctionComponent<FooterRecordProps> = (props: FooterRecordProps) => {
    const className = useMergedClassName("farpov_footer_record_container", props.class);
    return (
        <div {...props} class={className}>
            <div class="farpov_footer_record_row">
                <i>farpov</i>
            </div>
            <div class="farpov_footer_record_row">
                <i>
                    <a href="https://beian.miit.gov.cn">湘ICP备2020019150号-3</a>
                </i>
            </div>
        </div>
    );
};
export default FooterRecord;
